import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;

export class ZIDXLoginTest implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxLoginTestContainer";
    }
    render() {
        // console.log("login test");
        let self=this;
        $(".zidxLoginContactModalButton", this.zidx.peakidxShadowRoot).on("click", function(e){
            e.preventDefault();
            self.showLoginForm();
            return false;
        });
        if (!this.zidx.isContactLoggedIn() && !this.zidx.isContactGuest()) {
            this.showLoginForm();
        }
    }
    showLoginForm(){
        let disableClose = false;
        let width = 0;
        let height = 0;
        if ($(window).width()! < 992) {
            width = Math.min(600, $(window).width()! - 20);
            height = Math.min(500, $(window).height()! - 20);
        } else {
            width = Math.min(800, $(window).width()! - 50);
            height = Math.min(600, $(window).height()! - 50);
        }
        let url=this.zidx.options.siteDomain+"/login/?forced=1&embedded=1&ztv="+Math.random();
        var modalContent1='<iframe id="zModalIframeLogin" src="'+url+'" scrolling="yes" frameborder="0"  style=" margin:0px; border:none; overflow:auto; -webkit-overflow-scrolling: touch; position:relative; " seamless="seamless" width="100%" height="98%" />';
        this.zidx.modalWindow.showModal(modalContent1,{
            'width':width,
            'height':height,
            "maxWidth":width,
            "maxHeight":height,
            "padding":0,

            "disableClose":disableClose,
            "fullscreen":false});
    }
}